document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="StickyAtc-"]').forEach(function (bar) {
    var sectionId = bar.dataset.sectionId;
    var trigger = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!trigger) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.setAttribute('hidden', '');
          } else {
            bar.removeAttribute('hidden');
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(trigger);

    var sourcePrice = document.getElementById('price-' + sectionId);
    var targetPrice = document.getElementById('StickyAtcPrice-' + sectionId);
    if (sourcePrice && targetPrice) {
      var priceObserver = new MutationObserver(function () {
        targetPrice.innerHTML = sourcePrice.innerHTML;
      });
      priceObserver.observe(sourcePrice, { childList: true, subtree: true });
    }

    var stickyButton = bar.querySelector('.sticky-atc__button');
    if (stickyButton) {
      var syncDisabled = function () {
        if (trigger.disabled) {
          stickyButton.setAttribute('disabled', '');
        } else {
          stickyButton.removeAttribute('disabled');
        }
      };
      var btnObserver = new MutationObserver(syncDisabled);
      btnObserver.observe(trigger, { attributes: true, attributeFilter: ['disabled'] });
    }
  });
});
